import type { FormatOptions } from "./format.types";

export const formatObject = (options: FormatOptions): string => {
  return options.style === "short"
    ? JSON.stringify(options.value)
    : JSON.stringify(options.value, null, 2);
};
